import React from 'react'
import * as urls from '../../constants/urls'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'

import logo from '../logo.png'

const styles = (theme) => ({
	root: {
		overflow: 'auto',
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		paddingBottom: theme.spacing.unit * 3,
		'-webkit-overflow-scrolling': 'touch', //For smooth scrolling on iPhones.
	},
	padding: {
		padding: theme.spacing.unit * 3
	},
    logoLink: {
    	display: 'block',
        marginTop: 'auto',
        alignSelf: 'center',
        paddingTop: theme.spacing.unit * 3,
    },
    logoImage: {
    	width: 150,
    },
})

const PageContent = ({ children, padding, classes, ...props }) => (
	<div className={classNames(classes.root, {[classes.padding]: padding})} {...props}>
		{children}
		<a href={urls.LANTMÄTERIET} className={classes.logoLink}>
			<img src={logo} alt="Lantmäteriet" className={classes.logoImage} />
		</a>
	</div>
)

export default withStyles(styles)(PageContent)



// WEBPACK FOOTER //
// ./src/components/Page/PageContent.js